import { createRouter, createWebHashHistory } from 'vue-router'
import HomeIndex from '../views/homeIndex.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: HomeIndex
  },
  {
    path: '/show',
    name: 'show',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "showpage" */ '../views/videoShow.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
